import React from 'react';
import { motion } from 'framer-motion';
import { Award, Map, Lock, ShieldCheck, Clock, CheckCircle } from 'lucide-react';
export function WhyChoose() {
  const features = [{
    icon: Award,
    title: 'Experienced',
    description: 'Aviation logistics professionals with real-world industry experience.'
  }, {
    icon: Map,
    title: 'Nationwide Service',
    description: 'Door-to-door coverage all over the United States.'
  }, {
    icon: Lock,
    title: 'Secure Transport',
    description: 'Specialized equipment, secure tie-downs and full chain-of-custody.'
  }, {
    icon: ShieldCheck,
    title: 'Fully Insured',
    description: 'Cargo insurance available for maximum protection.'
  }, {
    icon: Clock,
    title: '24/7 Support',
    description: 'We are ready when you need us, day or night.'
  }, {
    icon: CheckCircle,
    title: 'On Time. Every Time.',
    description: 'We understand AOG deadlines and the importance of uptime.'
  }];
  return <section id="about" className="py-24 bg-[#0d1323] relative border-b border-white/5" data-id="element-418" data-mp="28giblca9htob">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-419" data-mp="2icv6uelggfl6">
        <div className="text-center mb-16" data-id="element-420" data-mp="2ie6929z95fa6">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4 uppercase" data-id="element-421" data-mp="2de1puc6ym6g9">
            Why Choose <span className="text-gold" data-id="element-422" data-mp="2rd1cxfetqdab">JetForce Aerospace</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-423" data-mp="2mezwz3cp2u32">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-navy rounded-2xl p-8 border border-gold/20 hover:border-gold/60 hover:shadow-gold-glow transition-all group" data-id="element-424" data-mp="312ba39oiym5a" data-mpi={index}>
              <div className="w-14 h-14 rounded-full bg-gold flex items-center justify-center mb-6 shadow-gold-glow group-hover:shadow-gold-glow-lg transition-all transform group-hover:-translate-y-1" data-id="element-425" data-mp="3n3a2kb2goykg">
                <feature.icon className="w-7 h-7 text-navy" data-id="element-426" data-mp="3vwn8cdlmjuny" />
              </div>

              <h3 className="text-xl font-heading font-bold text-white mb-3 uppercase tracking-wide" data-id="element-427" data-mp="4pkefeeejaa1">
                {feature.title}
              </h3>
              <p className="text-slate-400 leading-relaxed" data-id="element-428" data-mp="9pghnbf9yxoj">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}